<template>
  <div class="pb-12 pt-0">
    <div class="flex items-center">
      <h2 class="font-semibold whitenowrap fsize14 mb-0">Platform</h2>

      <div class="flex w-full flex-wrap ml-4">
        <el-select
          v-model="selectedStories"
          value-key="page"
          collapse-tags
          placeholder="Select"
          class="z-index-option w-full"
        >
          <el-option
            v-for="item in optionStories"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
      <h2
        class="font-semibold whitenowrap fsize14 mb-0"
        v-if="selectedStories === 'Mobile'"
      >
        Tag
      </h2>
      <div
        class="flex w-full flex-wrap ml-4"
        v-if="selectedStories === 'Mobile'"
      >
        <el-select
          v-model="fieldMobileTag"
          value-key="page"
          collapse-tags
          placeholder="Select"
          class="z-index-option w-full"
        >
          <el-option
            v-for="item in optionMobileTags"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>

      <h2 class="font-semibold whitenowrap fsize14 mb-0 pl-3">As a</h2>

      <div class="flex w-full mx-4">
        <el-select
          v-model="selectedRole"
          value-key="_id"
          collapse-tags
          placeholder="Select"
          class="z-index-option w-full"
        >
          <el-option
            v-for="item in roles"
            :key="item._id"
            :label="item.name"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
      <h2 class="font-semibold whitenowrap fsize14 mb-0">, on</h2>

      <div class="flex w-full flex-wrap ml-4">
        <el-select
          v-model="selectedPage"
          value-key="page"
          collapse-tags
          placeholder="Select"
          class="z-index-option w-full"
        >
          <el-option
            v-for="item in pages"
            :key="item._id"
            :label="item.page"
            :value="item"
          >
          </el-option>
        </el-select>
      </div>
    </div>
  </div>
</template>
<script>
// import "../scss/Index.scss";
import api from "@/builder/api";
import axios from "axios";
// import Table from "./Table.vue";

import Repository from "@/Apicall/masters/masterRepository.js";

import { mapState, mapGetters } from "vuex";
// import Wireframe from "./WireframeTab.vue";
import alertMixin from "@/builder/mixins/alerts";
export default {
  mixins: [alertMixin],
  components: {
    // Table,
    // Wireframe,
  },
  data() {
    return {
      selectedRole: {},
      selectedPage: {},
      fieldMobileTag: "",
      selected: {},
      optionStories: ["Website", "Mobile", "Admin"],
      optionMobileTags: ["Android", "iOS", "Both"],
      selectedStories: "",
      taskList: [],
      pages: "",
      manHrs: [],
      component: {},
      pages: [],
      singleComponent: "",
      roles: [],
    };
  },

  computed: {
    windowWidth() {
      return this.$store.state.windowWidth;
    },

    currentRoute() {
      return this.$route.name;
    },

    ...mapState("design", [
      "showTestCases",
      "selectedSprint",
      "selectedSubSprint",
      "selectedComponent",
      "selectedStory",
      "setselectedroles",
      "selectedMobileTag",
    ]),
    ...mapState("user", ["selectedProject", "brainedUserDetails"]),
    ...mapGetters("user", {
      isBusinessAnalyst: "isBusinessAnalyst",
      isClient: "isClient",
    }),

    filteredPages() {
      const pages = this.selectedRole.pages.filter((x) => {
        return this.selectedProject.selectedPages.find((y) => x._id === y._id);
      });
      this.selectedPage = pages[0];
      return pages;
    },
  },
  watch: {
    async selectedSprint() {
      // await this.getPages();
      await this.selectComponent(this.components[0]);
    },
    selectedPage(newValue) {
      this.selectComponent(newValue);
    },
    async selectedStories(newValue) {
      await this.selectedStoriesType(newValue);
      console.log(newValue, "newValue");
      if (newValue === "Mobile") {
        console.log("Done");
        this.fieldMobileTag = "Both";
      }
      await this.getRolesOnMount();
      await this.getPagesOnMount();
    },
    selectedRole(newValue) {
      this.selectedRolesData(newValue);
    },
    fieldMobileTag(value) {
      this.funcMobileTag(value);
    },
    // async selectedComponent(oldValue) {
    //   if (oldValue.ticketID == "MAN00001") {
    //     await this.init();
    //   }
    // },
    // async selectedStory(newValue) {
    //   if (newValue.page !== this.selectedComponent._id) {
    //     this.WireframechangeComponent();
    //   }
    // },
    // async selectedProject(newValue, oldValue) {
    //
    //   await this.init();
    // }
  },

  methods: {
    selectedRolesData(name) {
      this.$store.commit("design/SET_SELECTED_ROLES", name);
    },
    selectedStoriesType(name) {
      this.$store.commit("design/SET_STORIES_TYPE", name);
    },
    selectComponent(name) {
      // if (this.$route.name === "stories") {
      // this.$router.push({ name: "stories" }).catch(() => {});
      this.$store.commit("design/SET_SELECTED_COMPONENT", name);
      // }

      // if (this.$route.name === "wireframe") {
      //   this.$router.push({ name: "wireframe" }).catch(() => {});
      //   this.$store.commit("design/SET_SELECTED_COMPONENT", name);
      // }
      // if (this.$route.name === "testcases") {
      //   this.$router.push({ name: "testcases" }).catch(() => {});
      //   this.$store.commit("design/SET_SELECTED_COMPONENT", name);
      // }
    },
    funcMobileTag(name) {
      this.$store.commit("design/SET_MOBILE_TAG", name);
    },
    backToStories() {
      this.$store.commit("design/SET_SHOW_TEST_CASES", false);
    },

    async getTaskList() {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await Repository.post(
            "/task-manager/project/gettasklist"
          );

          this.taskList = data.data.map((x) => ({
            text:
              x.name == "Sprint 0" || x.name == "Version 0"
                ? "Default"
                : x.name,
            value: x,
          }));

          resolve(this.taskList);
        } catch (error) {
          reject(error);
        }
      });
    },

    // async getPagesFromStories() {
    //   return new Promise(async (resolve, reject) => {
    //     try {
    //       const { data } = Repository.post("/uibuilder/getPages", {
    //         projectName: this.selectedProject.projectName,
    //       });
    //       resolve(data);
    //     } catch (error) {
    //       reject(error);
    //     }
    //   });
    // },
    async getPages() {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await this.$store.dispatch("builder/getPages", {
            projectId: this.selectedProject._id,
            projectName: this.selectedProject.projectName,
            tasklistID: this.selectedSprint._id,
            type: this.selectedStories,
          });

          this.pages = data.map((x) => ({ ...x, Hrs: 0 }));
          // this.$store.commit("design/SET_COMPONENTS", data);
          // this.$store.commit("design/SET_SELECTED_COMPONENT", this.pages[0]);

          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getPagesOnMount() {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await this.$store.dispatch("builder/getPages", {
            projectId: this.selectedProject._id,
            projectName: this.selectedProject.projectName,
            tasklistID: this.selectedSprint._id,
            taskListIdSub: this.selectedSubSprint._id,
          });

          this.pages = data.map((x) => ({ ...x, Hrs: 0 }));
          // this.$store.commit("design/SET_COMPONENTS", data);
          // this.$store.commit("design/SET_SELECTED_COMPONENT", this.pages[0]);

          // this.selectComponent(data[0]);
          this.$store.commit("design/SET_SELECTED_COMPONENT", "");

          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },

    async getAllComponents() {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await Repository.post(
            "zoho/projects/tasks/components",
            {
              tasklistID: this.selectedSprint._id,
            }
          );
          // this.components = data.data.map(x => ({ ...x, Hrs: 0 }));
          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },

    requirements() {
      this.$router.push({ name: "requirements" });
    },

    async init() {
      // await this.getAllComponents();
      // await this.getPagesFromStories();

      // await this.getPages();

      let component;
      if (
        Object.keys(this.selectedComponent).length &&
        this.selectedSprint._id === this.selectedComponent.taskListID
      ) {
        this.selectedPage = this.selectedComponent;
      } else {
        this.selectedPage = this.pages[0];
      }
      this.singleComponent = component;
      this.$store.commit("design/SET_SELECTED_COMPONENT", this.selectedPage);
      // this.$router.push({ name: "stories" }).catch(() => {});
    },

    async WireframechangeComponent() {
      const index = this.components.findIndex(
        (x) => x.name === this.selectedStory.page
      );
      this.$store.commit(
        "design/SET_SELECTED_COMPONENT",
        this.components[index]
      );
    },

    numbers() {
      for (let index = 0; index < 100; index++) {
        this.manHrs.push({ text: `${index} Hrs`, value: `${index} Hrs` });
      }
    },
    async getRolesOnMount() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.displayName,
        taskListID: this.selectedSprint._id,
        taskListIdSub: this.selectedSubSprint._id,
      };
      let data = await this.$store.dispatch("builder/getRoles", payload);
      // this.roles = data.map((x) => ({
      //   text: x.name,
      //   value: x,
      // }));
      this.roles = data;
      this.$store.commit("design/SET_SELECTED_ROLES", "");

      // await this.selectedRolesData(data[0]);
      // this.selectedRole = this.selectedRole ? this.selectedRole : this.roles[0];
      // if (
      //   Object.keys(this.selectedRole).length &&
      //   this.selectedSprint._id === this.selectedRole.taskListID
      // ) {
      //   this.selectedRole = this.selectedRole;
      // } else {
      //   this.selectedRole = this.roles[0];
      // }
    },
    async getRoles() {
      let payload = {
        projectId: this.selectedProject._id,
        projectName: this.selectedProject.displayName,
        taskListId: this.selectedSprint._id,
        type: this.selectedStories,
      };
      let data = await this.$store.dispatch("builder/getRoles", payload);
      // this.roles = data.map((x) => ({
      //   text: x.name,
      //   value: x,
      // }));
      this.roles = data;

      // this.selectedRole = this.selectedRole ? this.selectedRole : this.roles[0];
      // if (
      //   Object.keys(this.selectedRole).length &&
      //   this.selectedSprint._id === this.selectedRole.taskListID
      // ) {
      //   this.selectedRole = this.selectedRole;
      // } else {
      //   this.selectedRole = this.roles[0];
      // }
    },
    setManHrs(item) {
      return new Promise(async (resolve, reject) => {
        try {
          const { data } = await Repository.post(
            "/zoho/projects/tasks/setManHrs",
            {
              page: item._id,
              taskListID: item.taskListID,
              manHrs: item.manHrs,
            }
          );
          resolve(data);
        } catch (error) {
          reject(error);
        }
      });
    },
  },

  async mounted() {
    // this.selectedStories = "Website";

    // await this.init();
    this.getRolesOnMount();
    this.getPagesOnMount();
    this.$store.commit("design/SET_STORIES_TYPE", "");

    this.numbers();
    // this.selectedRole = this.selectedProject.selectedRoles[0];
  },
};
</script>
<style>
.cust-bg-lightgrey th {
  background-color: #f4f5f6 !important;
  padding: 20px 0px;
  /* font-size: 18px; */
  line-height: 27px;
  font-weight: 600;
  color: #282828;
}
.iclr {
  color: rgba(255, 255, 255, 0.5);
}
.iclr2 {
  background-color: #b0449f;
  color: #b0449f;
}

.cust-bg-selected {
  background: rgba(156, 21, 135, 0.2);
}
.pl-18rem {
  padding-left: 18rem;
}
</style>
